
import { of as observableOf,  Subject ,  Observable } from 'rxjs'

import { mergeMap,  catchError } from 'rxjs/operators'
import { useRef, useEffect } from 'react'
import Button from '@mui/material/Button'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import styles from './Quotes.pcss'
import { StoreThunkDispatch } from 'store/state'
import { createQuote } from 'admin/services/quotes/actions'
import { message } from 'services/snackbar'

export function CreateStatusIdeaPanel(props: { onCreated: () => void }) {
  const { onCreated } = props
  const dispatch = useDispatch<StoreThunkDispatch>()
  const textRef = useRef<HTMLTextAreaElement>(null)
  const authorRef = useRef<HTMLInputElement>(null)
  const languageRef = useRef<HTMLInputElement>(null)
  const tagsRef = useRef<HTMLInputElement>(null)

  const create$ = useRef<Subject<{ status: string, author?: string, tags?: string[], language?: string }>>(undefined)

  useEffect(() => {
    create$.current = new Subject()
    create$.current.pipe(mergeMap((params: { status: string, author?: string, tags?: string[], language?: string }) => {
      return dispatch(createQuote(params.status, params.author, params.tags, params.language)).pipe(
        catchError((e: Error) => {
          dispatch(message(`An error occurred: ${e.message}`))
          return observableOf({ error: true })
        })
      )
    }))
      .subscribe((response) => {
        if (!response.error) {
          dispatch(message('Status added!'))
          onCreated()
        }
      })

    return () => create$.current?.unsubscribe()
  }, [dispatch, onCreated])

  const create = () => {
    const status = textRef.current?.value.trim()
    const author = authorRef.current?.value.trim()
    const language = languageRef.current?.value.trim()
    const tags = tagsRef.current?.value.split(',').map(value => value.trim()).filter(Boolean)

    if (status) {
      create$.current?.next({ status, author, tags, language })
      ; (textRef.current as any).value = ''
      ; (authorRef.current as any).value = ''
      ; (tagsRef.current as any).value = ''
      ; (languageRef.current as any).value = ''
    }
  }
  return (
    <section className={styles['box-create']}>
      <h3 className={styles['add-title']}>Add new quote</h3>
      <textarea className={styles.textarea} ref={textRef} placeholder="Enter text" rows={1} />
      <div className={styles['box-create-footer']}>
        <input type="text" placeholder="Author" ref={authorRef} />
        <input type="text" placeholder="Tags (comma-separated)" ref={tagsRef} />
        <input type="text" placeholder="Language" ref={languageRef} />
        <Button color="primary" variant="contained" size="small" onClick={create}>
          <FormattedMessage id="actions.save" />
        </Button>
      </div>
    </section>
  )
}
